/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'

export const useMergedRefs = refs =>
  useCallback(current => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(current)
      } else if (ref && !Object.isFrozen(ref)) {
        ref.current = current
      }
    })
  }, refs)
